import Vue from 'vue'
import GoodsOption from './goods.vue'

const Goods = Vue.extend(GoodsOption)
export function templateGoodsVue({
  module,
  postMessage,
  callModule,
  exposeDirective
}) {
  const goods = new Goods({
    propsData: {
      module
    },
    methods: {
      postMessage,
      callModule
    },
    directives: {
      tangramExpose: exposeDirective
    }
  }).$mount()
  return goods.$el
}
